// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"SJ-z","loadingMedia":"TJ-z","reviewsImagesAndVideos":"UJ-z","limitHeight":"VJ-z"};